import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { LoadingIndicator } from "../components/assets";

const UnsubscribePage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading, success, error

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const response = await fetch(`/api/unsubscribe/${token}`);
        if (response.ok) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      } catch (error) {
        setStatus("error");
      }
    };

    if (token) {
      unsubscribe();
    }
  }, [token]);

  return (
    <Box
      id="unsubscribe-page"
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0A0F0D, #1A1F1D)",
        color: "#FFFFFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
        textAlign: "center",
      }}
    >
      <Box id={`unsubscribe-${status}`}>
        {status === "loading" && (
          <LoadingIndicator text="Unsubscribing..." />
        )}
        {status === "success" && (
          <>
            <Typography
              variant="h4"
              sx={{ mb: 2, color: "success.main" }}
            >
              🎉 Unsubscribed Successfully!
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              You've been removed from our waitlist. We're sorry to see you go!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              If you change your mind, you can always join again from our landing page.
            </Typography>
          </>
        )}
        {status === "error" && (
          <>
            <Typography
              variant="h4"
              sx={{ mb: 2, color: "error.main" }}
            >
              ❌ Unsubscribe Error
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              There was a problem processing your unsubscribe request.
              Please try again later or contact support.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Your email may already be unsubscribed or the link may be invalid.
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default UnsubscribePage;
